import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import Slider from "./add-to-cart";
import { useGetProductDetailsQuery } from "../../../services/productDetailAPI";
import "./style.scss"


function QuickViewModal({ isOpenQuickViewModal, handlecloseQuikViewMOdal, quickViewId }) {
    const { data} = useGetProductDetailsQuery(quickViewId);
    return (
        <div
            className={`modal fade quick-view-modal ${isOpenQuickViewModal ? "show d-block" : ""}`}
            tabIndex="-1"
            style={{ background: "rgba(0,0,0,0.5)" }}
        >
            <div className="modal-dialog modal-dialog-centered">
                <div className="modal-content">
                    <div className="modal-header">
                        <button
                            type="button"
                            className="btn-close"
                            onClick={handlecloseQuikViewMOdal}
                        ></button>
                    </div>
                    <div className="modal-body">
                        <div className="row">
                            <Slider  product={data?.product} quickViewId={quickViewId}/>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default QuickViewModal;
